import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const useIdleLogout = (timeout) => {
  const navigate = useNavigate();

  useEffect(() => {
    let timer;
    const logout = () => {
      localStorage.removeItem("authToken");
      localStorage.setItem("forceLogout", Date.now()); // notify other tabs
      navigate("/login");
    };
    const resetTimer = () => {
      clearTimeout(timer);
      timer = setTimeout(logout, timeout);
    };
    const activityEvents = ["mousemove", "keydown", "mousedown", "touchstart"];
    activityEvents.forEach((event) => window.addEventListener(event, resetTimer));
    // listen for logout from other tabs
    const handleStorage = (e) => {
      if (e.key === "forceLogout") { logout(); }
    };
    window.addEventListener("storage", handleStorage);
    resetTimer();
    return () => {
      activityEvents.forEach((event) => window.removeEventListener(event, resetTimer));
      window.removeEventListener("storage", handleStorage);
      clearTimeout(timer);
    };
  }, [timeout, navigate]);
};

export default useIdleLogout;
